module.exports = __webpack_public_path__ + "static/servicecorsal3-ee2cdfe247a122714c9cc5e2a74cd5d4.png";